import { useEffect, useState } from 'preact/hooks';
import { _className } from '../../../utils/classname.utils';
import style from './Stepper.css';

export default function Step({ className = '', isActive, children, ...props }) {
  const [showing, setShowing] = useState(isActive);

  // ATTENTION : this is needed for keeping the fade effect
  // but at the same time we should remove the step elements out of the DOM focus
  useEffect(() => {
    setTimeout(() => {
      setShowing(isActive);
    }, 300);
  }, [isActive]);
  return (
    <div
      className={`${className} ${style.step} ${_className(
        isActive,
        style.active,
      )}`}
      {...props}
    >
      {showing ? children : <></>}
    </div>
  );
}
